export const DATE_TIME_FORMAT_STYLE = 'YYYY-MM-DD HH:mm:ss';

// export const COMMON_UPLOAD_URL = '/commons/upload';

export const DOWNLOAD_URL = {
  IOS: '',
  ANDROID: ''
};

// export const NE_CAPTCHA_ID = '2de7d80c165f4d04be5667d7be008f75';
export let NE_CAPTCHA_ID = process.env.VUE_APP_NE_CAPTCHA_ID || '';
export let NE_CAPTCHA_ID_SMART = process.env.VUE_APP_NE_CAPTCHA_ID_SMART || '';

export let RES_PUBLIC_KEY = process.env.VUE_APP_RES_PUBLIC_KEY || '';

export let TIM_ENV = process.env.VUE_APP_TIM_ENV || '';

